var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLessonGame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1728",
    "data-name": "Group 1728",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 81.615,
    height: 90.674,
    viewBox: "0 0 81.615 90.674",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_564",
    "data-name": "Rectangle 564",
    width: 81.615,
    height: 90.674,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1726",
    "data-name": "Group 1726",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1616",
    "data-name": "Path 1616",
    d: "M54.113,5.564a18.934,18.934,0,0,1,2.67,23.121c-.683,1.122-1.69,2.04-2.392,3.046-.124.177-.29.208-.205.523L76.074,43.094a10.4,10.4,0,0,1,5.293,8.3,120.422,120.422,0,0,1,.011,15.27,11.58,11.58,0,0,1-4.752,8.631C58.967,83.865,46.98,97.239,26.37,86.944c-6.327-3.16-14-7.1-20-10.738C2.729,74,.566,71.014.238,66.653A122.014,122.014,0,0,1,.227,51.591a10.462,10.462,0,0,1,5.044-8.34l22.149-11c.085-.315-.082-.346-.205-.523-1.717-2.462-3.086-3.655-4.135-6.739C16.661,6.122,40.141-8.408,54.113,5.564M38.665,5.549c-4.794.575-9.388,4.785-10.725,9.35A13.455,13.455,0,0,0,47.08,30.692c13.012-6.821,7.1-27.005-8.415-25.144M32.856,35.6l-.777.164L7.693,47.974a4.907,4.907,0,0,0,.694,8.438C21.393,61.338,34.473,74.449,49.1,68.47c8.111-3.315,16.139-8.633,24.255-12.131a4.9,4.9,0,0,0,.557-8.365L49.526,35.766l-.777-.164V49.3a12.1,12.1,0,0,1-1.011,2.753c-2.684,4.9-11.187,4.9-13.871,0A12.112,12.112,0,0,1,32.856,49.3Zm10.665,1.673a15.427,15.427,0,0,1-5.437,0v11.4c0,2.36,5.437,2.36,5.437,0ZM43.1,75.333H38.5A30.121,30.121,0,0,1,30,73.069L5.672,60.9v6.587c0,1.014,1.705,3.319,2.736,3.747,13.951,6.075,26.139,19.4,42.364,12.077C58.6,79.78,66.5,74.505,74.161,70.529a6.879,6.879,0,0,0,1.981-4.5V61.218c0-.026-.3-.407-.426-.224L51.608,73.069A29.443,29.443,0,0,1,43.1,75.333",
    transform: "translate(0 0)",
    fill: "#2a77eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1617",
    "data-name": "Path 1617",
    d: "M51.228,152.2v13.7a12.1,12.1,0,0,0,1.011,2.753c2.683,4.9,11.187,4.9,13.871,0a12.1,12.1,0,0,0,1.011-2.753V152.2l.777.164,24.386,12.208a4.9,4.9,0,0,1-.557,8.365c-8.116,3.5-16.144,8.816-24.255,12.131-14.627,5.978-27.707-7.133-40.714-12.058a4.907,4.907,0,0,1-.694-8.438l24.386-12.208Zm-14.263,9.472c-9,.841-8.041,13.123.973,12.909,9.663-.23,8.979-13.839-.973-12.909",
    transform: "translate(-18.371 -116.601)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1618",
    "data-name": "Path 1618",
    d: "M57.08,274.8a16.228,16.228,0,0,0,4.6,0,29.441,29.441,0,0,0,8.505-2.264l24.108-12.075c.129-.183.426.2.426.224V265.5a6.88,6.88,0,0,1-1.981,4.5c-7.658,3.976-15.561,9.251-23.39,12.786-16.224,7.325-28.413-6-42.364-12.077-1.03-.428-2.736-2.733-2.736-3.747v-6.587l24.325,12.165A30.124,30.124,0,0,0,57.08,274.8",
    transform: "translate(-18.578 -199.469)",
    fill: "#d5d5d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1619",
    "data-name": "Path 1619",
    d: "M128.287,23.326c15.51-1.861,21.427,18.323,8.415,25.144a13.455,13.455,0,0,1-19.14-15.794c1.337-4.565,5.931-8.775,10.725-9.35",
    transform: "translate(-89.621 -17.777)",
    fill: "#fa0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1620",
    "data-name": "Path 1620",
    d: "M168.253,159.355v11.4c0,2.359-5.437,2.359-5.437,0v-11.4a15.426,15.426,0,0,0,5.437,0",
    transform: "translate(-124.731 -122.08)",
    fill: "#d5d5d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1621",
    "data-name": "Path 1621",
    d: "M169.2,322.058a16.224,16.224,0,0,1-4.6,0Z",
    transform: "translate(-126.101 -246.725)",
    fill: "#5f636d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1622",
    "data-name": "Path 1622",
    d: "M58.892,192.55c9.952-.93,10.635,12.679.973,12.909-9.014.214-9.975-12.068-.973-12.909m-.222,4.377a2.631,2.631,0,0,0-1.785,1.567c-.706,3.2,5.325,3.392,5.619.8.24-2.115-2.121-2.718-3.835-2.365",
    transform: "translate(-40.298 -147.475)",
    fill: "#2a77eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1623",
    "data-name": "Path 1623",
    d: "M168.291,39.325c5.75-1.175,6.325,7.2,1.215,7.456-4.581.23-5.274-6.626-1.215-7.456",
    transform: "translate(-124.824 -27.931)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1624",
    "data-name": "Path 1624",
    d: "M72.506,211.1c1.714-.353,4.075.249,3.835,2.365-.294,2.594-6.325,2.4-5.619-.8a2.631,2.631,0,0,1,1.785-1.567",
    transform: "translate(-54.135 -161.649)",
    fill: "#abff00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLessonGame);
export default __webpack_public_path__ + "static/media/lesson_game.1206bd14f494e6f9d07d708de0044a24.svg";
export { ForwardRef as ReactComponent };